export function useAnimatedNative(): boolean {
  return false;
}
